import { gateway } from "../../../gateway";
import { KanbanCategory } from "../interfaces/kanbanCategory.interface";

export const updatekanbanCategoriesAction = async (categoryUid: string, updates: Partial<KanbanCategory>) => {
    try {
        if (!categoryUid) {
            throw new Error("Category UID is required");
        }

        const response = await gateway.patch(`/kanban-categories/self/${categoryUid}`, updates);

        const category = response.data?.data || response.data;

        if (!category) {
            throw new Error("Invalid response from server");
        }

        return category;
    } catch (error: any) {
        console.error("Error updating kanban category:", error);
        const errorMessage = error?.response?.data?.message || error?.message || "Failed to update kanban category";
        throw new Error(errorMessage);
    }
}